/**
 * Управление темой оформления (светлая/тёмная).
 * Тема применяется через атрибут data-bs-theme на html и используется
 * Element Plus, splash-screen и при необходимости другими стилями.
 */

const STORAGE_KEY = "theme";
export type ThemeValue = "light" | "dark";

/** Значение по умолчанию при первом заходе: тёмная тема для всех */
const DEFAULT_THEME: ThemeValue = "dark";

/**
 * Применить тему к документу (html)
 */
export function applyTheme(value: ThemeValue): void {
  document.documentElement.setAttribute("data-bs-theme", value);
}

/**
 * Прочитать сохранённую тему из localStorage.
 * Если ключа нет — возвращает DEFAULT_THEME (тёмная для всех).
 */
export function getStoredTheme(): ThemeValue {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw === "light" || raw === "dark") return raw;
  return DEFAULT_THEME;
}

/**
 * Сохранить тему в localStorage и применить к документу
 */
export function setTheme(value: ThemeValue): void {
  localStorage.setItem(STORAGE_KEY, value);
  applyTheme(value);
}

/**
 * Инициализация темы при загрузке приложения.
 * Вызывать один раз при старте (например, из App.vue или LayoutService).
 */
export function initTheme(): void {
  applyTheme(getStoredTheme());
}

/**
 * Переключить тему (light -> dark, dark -> light) и вернуть новое значение
 */
export function toggleTheme(): ThemeValue {
  const next: ThemeValue = getStoredTheme() === "dark" ? "light" : "dark";
  setTheme(next);
  return next;
}
